/**
 * Enums that represent control default values when not set
 */
export enum ControlDefaults {
    EmptySelect = '-',
    OrientationPercent = '%',
    OrientationDollar = '$'
}
